(() => {
  // The German campaign opens the German market once per browser session.
  // A later deliberate country change remains the customer's choice.
  const destination = document.getElementById('StadiartGermanDestination');
  try {
    if (!sessionStorage.getItem('stadiart-de-destination-v1')) {
      sessionStorage.setItem('stadiart-de-destination-v1', 'DE');
      const landing = new URL(window.location.href);
      if (destination && !landing.searchParams.has('country')) {
        // Keep campaign attribution, selected variants and anchors through localization.
        destination.querySelectorAll('[name="return_to"]').forEach(input => {
          input.value = landing.pathname + landing.search + landing.hash;
        });
        destination.requestSubmit();
      }
    }
  } catch (_) { /* The visible native destination form remains available. */ }
  const initialized = new WeakSet();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const dayInPrague = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Prague',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
  const formatNumber = new Intl.NumberFormat('de-DE');
  const dateKey = () => {
    const parts = Object.fromEntries(dayInPrague.formatToParts(new Date()).map(part => [part.type, part.value]));
    return `${parts.year}-${parts.month}-${parts.day}`;
  };
  const updateCounter = root => {
    const baselineDate = Date.parse(`${root.dataset.baselineDate}T00:00:00Z`);
    const today = Date.parse(`${dateKey()}T00:00:00Z`);
    const days = Math.max(0, Math.floor((today - baselineDate) / 86400000));
    const baseline = Number(root.dataset.baselineOrders);
    const average = Number(root.dataset.dailyAverage);
    const estimate = root.querySelector('[data-sa-de-estimate]');
    if (!estimate || !Number.isFinite(days + baseline + average)) return;
    estimate.textContent = formatNumber.format(baseline + days * average);
  };
  const initializeRoutes = root => {
    const map = root.querySelector('.sa-de-map');
    if (!map) return;
    const regions = new Map(Array.from(map.querySelectorAll('[data-sa-de-map-region]'), country => [country.dataset.saDeMapRegion, country]));
    const origin = { x: 464.5, y: 335 };
    const choosePoint = country => {
      if (!country || typeof country.isPointInFill !== 'function') return null;
      const bounds = country.getBBox();
      const point = map.createSVGPoint();
      for (let attempt = 0; attempt < 80; attempt++) {
        point.x = bounds.x + Math.random() * bounds.width;
        point.y = bounds.y + Math.random() * bounds.height;
        if (country.isPointInFill(point) && Math.hypot(point.x - origin.x, point.y - origin.y) > 12) return point;
      }
      return null;
    };
    root.querySelectorAll('[data-sa-de-route]').forEach((route, index) => {
      const region = index < 14 ? 'DE' : index < 25 ? 'CZ' : index < 28 ? 'PL' : 'SK';
      const reroute = () => {
        const point = choosePoint(regions.get(region));
        if (!point) return;
        const dx = point.x - origin.x;
        const dy = point.y - origin.y;
        const bend = (Math.random() - .5) * .45;
        const cx = origin.x + dx / 2 - dy * bend;
        const cy = origin.y + dy / 2 + dx * bend;
        route.setAttribute('d', `M${origin.x},${origin.y} Q${cx.toFixed(1)},${cy.toFixed(1)} ${point.x.toFixed(1)},${point.y.toFixed(1)}`);
      };
      reroute();
      const duration = 2.6 + Math.random() * 2.8;
      route.style.setProperty('--sa-de-route-duration', `${duration.toFixed(2)}s`);
      route.style.setProperty('--sa-de-route-delay', `${(-Math.random() * duration).toFixed(2)}s`);
      route.addEventListener('animationiteration', reroute);
    });
  };
  const initialize = root => {
    if (initialized.has(root) || root.dataset.saDeReady === 'true') return;
    initialized.add(root);
    root.dataset.saDeReady = 'true';
    updateCounter(root);
    initializeRoutes(root);
    let inView = !('IntersectionObserver' in window);
    const syncAnimation = () => {
      root.dataset.animated = String(!reducedMotion.matches && inView && !document.hidden);

    };
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        inView = entries[0].isIntersecting;
        syncAnimation();
      }, { threshold: 0.1 });
      observer.observe(root);
    }
    reducedMotion.addEventListener('change', syncAnimation);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) updateCounter(root);
      syncAnimation();
    });
    syncAnimation();
  };
  const initializeAll = () => document.querySelectorAll('[data-sa-de-shipping]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
  window.setInterval(() => {
    if (!document.hidden) document.querySelectorAll('[data-sa-de-shipping]').forEach(updateCounter);
  }, 60000);
})();
